/** @file Error-boundary fallback: translated crash line, the error text, and a retry button. */
import type { FallbackProps } from 'react-error-boundary';
import { errorText } from './i18n/errorText';
import { useT } from './i18n/useT';

/** Used by App (around the current screen) and DockLayout (around each panel). */
export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const t = useT();
  return (
    <div role="alert" className="shell-card shell-error">
      <p>{t('errors.crashed')}</p>
      <pre>{errorText(t, error)}</pre>
      <button type="button" onClick={() => { resetErrorBoundary(); }}>{t('shell.retry')}</button>
    </div>
  );
}
